// extracted by mini-css-extract-plugin
export default {"searchBar":"searchModule_searchBar__JGNYY"};